import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useSelector } from "react-redux";
import themes from "./theme";

const AppTheme = ({ children }) => {
  const activeTheme = useSelector((state) => state.theme.activeTheme);
  const theme = themes[activeTheme] ?? themes["waya"];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default AppTheme;